import React from 'react';
import PropTypes from 'prop-types';

const Footer = ({ children }) => (
  <div id="footer" className="flex-row flex--left">
    <span style={{ marginLeft: 10 }} >
      {/* Made with <span style={{ color: '#d0c504' }}>&#9829;</span> by <a target="_blank" href="http://i4.com.tr/">i4</a> */}
      Made by <a style={{ color: '#d0c504' }} target="_blank" href="http://i4.com.tr/">i4</a> and the INGV team with financial support from the 
      <a style={{ color: '#d0c504' }} target="_blank" href="https://istituto.ingv.it/it/attivita-di-ricerca/progetti-e-convenzioni/accordo-quadro.html#convenzioni"> DPC-INGV Agreement B2 2019-2021</a>, EPOS-Italia 
      <a style={{ color: '#d0c504' }} target="_blank" href="https://www.epos-italia.it/it/progetti-della-jru"> PE2023</a>, and 
      <a style={{ color: '#d0c504' }} target="_blank" href="https://www.geo-inquire.eu/"> Geo-INQUIRE</a>.
    </span>
    {children}
  </div>
);

Footer.propTypes = {
  children: PropTypes.array,
};

Footer.defaultProps = {
  children: null,
};

export default Footer;



// WEBPACK FOOTER //
// ./src/components/Footer.js